<template>
<div>
  <!-- 提示区 -->
  <div class="card-tips">
    <div class="title">新建工单</div>
    <div class="button">
      <a-button type="primary" @click="reback">返回列表</a-button>
    </div>
  </div>

  <div class="card-wrapper">
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :colon="false" v-bind="layout">
      <a-form-model-item label="产品类型" prop="productType">
        <!-- <a-input v-model="ruleForm.productType" placeholder="请输入产品类型" /> -->
        <a-select @change="typeChange" placeholder="请选择产品类型" :getPopupContainer="triggerNode => triggerNode.parentNode">
          <a-select-option v-for="item in typeDict" :key="item.key">{{item.value}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="产品版本" prop="version">
        <a-input v-model="ruleForm.version" placeholder="请输入产品版本，如：dm8_2021_0712" />
        <div class="tip">
          产品版本查询方法：DM7:select * from v$version; DM8:select id_code();
        </div>
      </a-form-model-item>
      <a-form-model-item label="问题描述" prop="name">
        <a-input v-model="ruleForm.name" placeholder="请简单描述问题" />
      </a-form-model-item>
      <a-form-model-item label="问题详情" prop="content">
        <!-- <a-textarea v-model="ruleForm.content" placeholder="请输入内容" style="min-height: 270px;" /> -->
        <com-editor v-model="ruleForm.content" :dataId="ruleForm.worksheetId" :confirmLoading.sync="confirmLoading" :height="getMaxHeight" ref="editor" placeholder="请输入内容（请勿填写敏感信息）" class="editor-container" @changeStatus="changeScreen" @helpShow="onShowHelp" :toolbars="toolbars"></com-editor>
      </a-form-model-item>
      <a-form-model-item label="操作系统" prop="os">
        <a-input v-model="ruleForm.os" placeholder="请输入操作系统，如：centos7" />
      </a-form-model-item>
      <a-form-model-item label="CPU类型" prop="cpu">
        <a-input v-model="ruleForm.cpu" placeholder="请输入CPU类型，如：x86" />
      </a-form-model-item>
       <a-form-model-item label="联系人" prop="contacter">
          <a-input v-model="ruleForm.contacter" placeholder="请输入联系人" />
       </a-form-model-item>
      <a-form-model-item label="联系电话" prop="phone">
        <a-input v-model="ruleForm.phone" placeholder="请输入联系电话" :maxLength="50" />
        <div style="height: 17px; line-height: 17px; margin-left: 12px">
          <p style="font-size: 12px; color: #777777;">达梦售后人员可能通过此电话与您沟通工单问题详情，请保持电话畅通。</p>
        </div>
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="email">
        <a-input v-model="ruleForm.email" placeholder="请输入常用邮箱" />
      </a-form-model-item>
    </a-form-model>
  </div>
  <div class="card-action">
    <a-button type="primary" ghost style="margin-right: 12px;" @click="toWorksheet">取消</a-button>
    <a-button type="primary" @click="handleSubmit('ruleForm')" :disabled="disabled">提交</a-button>
  </div>
</div>
</template>

<script>
import {
  Worksheet
} from '@/models/Worksheet'
import {
  addWorksheet
} from "@/request/worksheet"
import {
  randomNumber
} from "@/utils/util";
import {
  getDict
} from "@/request/dict"
import {
  user
} from "eco-cli"
const {
  getInfo
} = user
import moment from 'moment'

import hljs from 'highlight.js' //导入代码高亮文件
import ComEditor from '../Modal/ComEditor.vue'

export default {
  components: {
    ComEditor
  },
  data() {
    const maxRule = {
      max: 100,
      message: "输入内容字符已达上限100个字符",
      trigger: ["blur", "change"]
    };
    const reqRule = {
      required: true,
      message: '输入不能为空',
      trigger: ['change', 'blur'],
    }
    return {
      confirmLoading: false,
      s_help: false,
      d_help: '',
      isFull: false,
      typeDict: [], // 产品类型字典
      toolbars: {
        bold: false, // 粗体
        italic: false, // 斜体
        header: false, // 标题
        underline: false, // 下划线
        strikethrough: false, // 中划线
        mark: false, // 标记
        superscript: false, // 上角标
        subscript: false, // 下角标
        quote: false, // 引用
        ol: false, // 有序列表
        ul: false, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: false, // 表格
        fullscreen: false, // 全屏编辑
        readmodel: false, // 沉浸式阅读
        htmlcode: false, // 展示html源码
        help: false, // 帮助
        /* 1.3.5 */
        undo: false, // 上一步
        redo: false, // 下一步
        trash: false, // 清空
        save: false, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: false, // 导航目录
        /* 2.1.8 */
        alignleft: false, // 左对齐
        aligncenter: false, // 居中
        alignright: false, // 右对齐
        /* 2.2.1 */
        subfield: false, // 单双栏模式
        preview: true, // 预览
      },

      layout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 18,
        },
      },
      ruleForm: Worksheet.blank(),
      rules: {
        productType: [{
          required: true,
          whitespace: true,
          message: "请选择产品类型！",
          trigger: "blur",
        }],
        version: [maxRule],
        os: [{
          max: 50,
          message: "输入内容字符已达上限50个字符",
          trigger: ["blur", "change"]
        }],
        cpu: [{
          max: 50,
          message: "输入内容字符已达上限50个字符",
          trigger: ["blur", "change"]
        }],
        phone: [{
          required: true,
          whitespace: true,
          message: "请输入联系电话！",
          trigger: "blur",
        }],
        name: [maxRule, {
          required: true,
          whitespace: true,
          message: "请输入问题描述！",
          trigger: "blur",
        }],
        content: [{
          max: 20000,
          message: "输入内容字符已达上限20000个字符",
          trigger: ["blur", "change"]
        }, {
          required: true,
          message: '请输入问题详情！',
          trigger: ['blur'],
        }],
        contacter: [
          {
            required: true,
            message: "请输入联系人真实姓名！",
            trigger: "change",
          },
          {
            max: 5,
            message: "输入内容字符已达上限5个字符",
            trigger: ["blur", "change"]
          }
        ],
        email: [{
          max: 320,
          message: "邮箱长度超出限制！",
          trigger: ["blur", "change"]
        }, {
          pattern: /^[a-z0-9A-Z][- | a-z0-9A-Z . _]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: "请输入正确的邮箱地址！",
          trigger: "blur",
        }]
      },
      disabled: false
    }
  },
  mounted() {
    this.ruleForm.worksheetId = moment().format('YYYYMMDD').concat(randomNumber(6));

    getDict('PRODUCT_TYPE').then(res => {
      this.typeDict = res
    })
    // console.log(this.ruleForm)
    this.getPhone()
  },
  computed: {
    getMaxHeight() {
      return window.matchMedia('(max-width:1400px)').matches ? '275px' : '350px'
    }
  },
  methods: {
    toWorksheet() {
      this.$router.push('/worksheet')
    },
    add() {
      this.ruleForm.worksheetId = moment().format('YYYYMMDD').concat(randomNumber(6))
    },
    handleSubmit(formName) {
      this.ruleForm.html = this.$refs.editor.getHtml();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          addWorksheet(this.ruleForm).then(() => {
            this.$message.success('提交成功');
            this.$router.push('/worksheet');
            setTimeout(() => {
              this.disabled = false
            }, 2000);
          })
          console.log(`submit`)
        } else {
          return false
        }
      })
    },

    // markdown组件
    changeScreen(isFull) {
      this.isFull = isFull;
    },
    onShowHelp(isShow, html) {
      this.s_help = isShow;
      this.d_help = html;
    },

    typeChange(value) {
      this.ruleForm.productType = value
    },

    // 用户手机号自动填入
    getPhone() {
      getInfo(true).then(res => {
        this.ruleForm.phone = res.phone;
        this.ruleForm.contacter = res.worksheetContacter;
        this.ruleForm.email = res.worksheetEmail;
      })
    },

    // 返回
    reback() {
      this.$router.push('/worksheet')
    },
  },
}
</script>

<style lang="scss" scoped>
.card-tips {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  margin-top: 9px;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #222222;
    line-height: 16px;
  }
}
.tip {
  height: 17px;
  line-height: 17px;
  margin-left: 12px;
  font-size: 12px; 
  color: #777777;
}

.card-title {
  margin: 10px 0 20px;
  font-size: 16px;
  font-weight: 600;
  color: #222222;
  line-height: 16px;
}

.card-wrapper {
  background: #ffffff;
  padding: 50px 25px 60px 50px;
}

.card-action {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

::v-deep .ant-select-dropdown {
  z-index: 9;
}
</style>
